const listeners = new Set<(ownerId: string) => void>();
/** Announce a journal change; subscribers still read their own journal. */
export function notifyConnectedTaskJournalChanged(ownerId: string) { listeners.forEach(listener => listener(ownerId)); }
export function subscribeConnectedTaskJournalChanged(listener: (ownerId: string) => void) {
  listeners.add(listener); return () => { listeners.delete(listener); };
}
